import { memo } from 'react';

interface SkipLinkProps {
  href?: string;
  children?: string;
}

export const SkipLink = memo(function SkipLink({
  href = '#main-content',
  children = 'Skip to main content',
}: SkipLinkProps) {
  return (
    <a
      href={href}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[#4f6cff] focus:text-white focus:rounded-lg focus:font-bold focus:shadow-lg"
      lang="en"
    >
      {children}
    </a>
  );
});

